import React from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const Accordion = ({ title, options, isOpen, onToggle, onSelect, selectedKey }) => {
  
  console.table("lets check all the props value", title, options, selectedKey )

  return (
    <div className="accordion">
      <div className="accordion-title" onClick={onToggle}>
        {title}
        <IoMdCheckmarkCircleOutline className="accordion_ic" />
      </div>
      {isOpen && (
        <div className="accordion-content">
          {options.map((option) => (
            <div
              key={option.key}
              className={`sub-option ${selectedKey === option.key ? "selected" : ""}`}
              onClick={() => onSelect(option.key)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Accordion;
